import ReferralService from '../services/referral/referralService';
import { ReferralDto } from '../services/referral/dto/referralDto';
import { CrudStoreBase } from './crudStoreBase';
import { defaultUser } from './userCrudStore';
import referralService from '../services/referral/referralService';

class ReferralStore extends CrudStoreBase<ReferralDto>{
  constructor() {
    super(ReferralService, defaultReferral)
  }

  public async getAll(request: any) {
    await referralService.getAllReferrals(request).then((result: any) => {
			this.dataSet = result;
		}).catch((error: any) => {
			console.error(error);
		});
  }
}

export const defaultReferral = {
  id: '',
  userId: 0,
  user: defaultUser,
  referralAgentId: 0,
  referralAgent: defaultUser,
  referralLink: '',
  token: '',
  isAffiliate: false,
  affiliateName: '',
  expirationDate: '',
  earnedAmount: 0,
}

export default ReferralStore;